import { isLoggedIn } from "graphql/variables";
import useOtpChallenge from "hooks/useOtpChallenge";

export default function useLogin() {
  const { clearChallenge } = useOtpChallenge();

  const handleLogin = ({ credentials, redirectTo }) => {
    if (!credentials) return;

    clearChallenge();

    const { accessToken, uid, client, expiry } = credentials;

    localStorage.setItem("token", accessToken);
    localStorage.setItem("client", client);
    localStorage.setItem("uid", uid);
    localStorage.setItem("expiry", expiry);

    isLoggedIn(true);

    window.open(redirectTo || "/", "_self");
  };

  return {
    handleLogin,
  };
}
